import { createRouter, createWebHistory} from 'vue-router'
import fy24 from "@/views/fy24.vue";
import lottery from "@/views/lottery.vue";
import verify from "@/views/verify.vue";
import search from "@/views/search.vue";
import detail_winner_list from "@/views/detail_winner_list.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/FY24_luckydraw',
  },
  {
    path: '/FY24_luckydraw',
    name: 'FY24_luckydraw',
    component: fy24
  },
  {
    path: '/FY24_luckydraw/lottery',
    name: 'lottery',
    component: lottery,
    meta: { requiresAuth: true }
  },
  {
    path: '/FY24_luckydraw/search',
    name: 'search',
    component: search,
    meta: { requiresAuth: true }
  },
  {
    path: '/FY24_luckydraw/verify',
    name: 'verify',
    component: verify
  },
  {
    path: '/lotterypage/detail_winner_list',
    name: 'detail_winner_list',
    component: detail_winner_list
  },
  {
    path: '/klook_cobrand',
    name: 'klook_cobrand',
    beforeEnter() {
      window.location.href = `https://www.tmnewa.com.tw/ec/campaign/klook_cobrand/`;
    }
  },
  { //防止空白頁面進入
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          const target = document.querySelector(to.hash);
          const navBar = document.getElementById('navBar');

          if (!target) {
            resolve({ top: 0 });
            return;
          }

          const navHeight = navBar?.offsetHeight ?? 0;
          const targetTop = target.getBoundingClientRect().top + window.scrollY;

          resolve({
            top: Math.max(0, targetTop - navHeight - 20),
            behavior: 'smooth',
          });
        });
      });
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { top: 0 };
  },
})

export default router
